import "./style.scss";

import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import type { MouseEventHandler } from "react";

interface IButtonCollapse {
    /* css properties */
    sx?: React.CSSProperties;
    /* collapse condition */
    collapse: boolean;
    /* onCollapse function to collapse */
    onCollapse?: MouseEventHandler;
    /* Text to display */
    btnText?: string;
    size?: "small" | "default";
}

/**
 * Button used with Collapse mui component
 * @param sx react css style
 * @param collapse condition to collapse
 * @param onCollapse collapse function
 * @param btnText button title
 */
const ButtonCollapse = ({ sx, collapse, onCollapse, btnText, size = "default" }: IButtonCollapse) => {
    return (
        <div
            className={`collapse-btn ${size}`}
            onClick={(e) => {
                e.stopPropagation();
                onCollapse && onCollapse(e);
            }}
            style={sx}
        >
            {btnText}
            {collapse ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
        </div>
    );
};

export default ButtonCollapse;
